<div class="app-wrapper" [ngClass]="{'with-overlay': view == VIEW_SEND_DONE || view == VIEW_SEND_ERROR || view == VIEW_SEND_NOT_ALLOWED }">
    <core-layout-modal-feedback class="modal-feedback" *ngIf="view == VIEW_SEND_DONE"
        [type]="'done'"
        [message]="'File'+filesPluralPart+' Sent'"
        [text]="'The file'+filesPluralPart+' you selected '+(filesPluralPart != '' ? 'have':'has')+' been sent'"
        [buttonText]="'Done'"
        (action)="onSent($event)">
    </core-layout-modal-feedback>
    <core-layout-modal-feedback class="modal-feedback" *ngIf="view == VIEW_SEND_ERROR"
        [type]="'fail'"
        [message]="'Error'"
        [text]="'Something went wrong. Please try again. If the error persists, please reach out to our support team through the Help Me button.'"
        [buttonText]="'Try again'"
        (action)="onError($event)">
    </core-layout-modal-feedback>
    <core-layout-modal-feedback class="modal-feedback" *ngIf="view == VIEW_SEND_NOT_ALLOWED" 
        [type]="'warning'"
        [message]="'Forbidden'"
        [text]="'You do not have permission to send these files. Please contact your admin for additional support.'"
        [buttonText]="'OK'" (action)="onError($event)">
    </core-layout-modal-feedback>
    <!-- plugin access -->
    <core-layout-error-not-found [hidden]="status != NOT_FOUND"></core-layout-error-not-found>


    <div class="loader plugin-section" [hidden]="status != LOADING">
        <div class="dimmed_outset">
            <core-title-section [title]="'PROJECT <small>(# . . .)</small>'"></core-title-section>
        </div>
        <div class="dimmed dimmed_main">
            <div class="dimmed_content">
                <div class="dimmed_flex">
                    <span class="dimmed_tag"></span>
                    <span class="dimmed_tag"></span>
                    <span class="dimmed_tag"></span>
                </div>
            </div>
        </div>
    </div>

    <nav class="tab_navigation">
        <div class="dimmed dimmed_main" [hidden]="status != LOADING">
            <div class="dimmed_nav">
                <div class="dimmed_subtitle"></div>
                <div class="dimmed_subtitle"></div>
                <div class="dimmed_subtitle"></div>
            </div>
        </div>
        <core-helpers-navigation-vertical-tabs
            [hidden]="partialProject != null || status == LOADING || status == NOT_FOUND"
            [menu]="menuProjects">
        </core-helpers-navigation-vertical-tabs>
    </nav>

    <section *ngIf="status == DONE && view != VIEW_DONE" class="main-content">
        <div class="app-main">
            <div class="request-main">
                <core-projects-breadcrumb-header *ngIf="project != null || partialProject != null" 
                    [project]="project ?? partialProject" 
                    [title]="breadcrumbText"
                    [breadcrumbs]="breadcrumbs">
                </core-projects-breadcrumb-header>

                <ng-container *ngIf="(project != null || (partialProject != null  && screenMode != DEFAULT_MODE)) && permission; else anyAccessToSend">
                    <div class="sub-header">
                        <div>
                            <h3>{{headerText}}</h3>
                            <p [hidden]="screenMode == SINGLE_FILE_MODE">Here you can select the file(s) to send</p>
                            <div class="instructions">
                                <a (click)="show = !show" class="trigger" [ngClass]="{'opened' : show == true}"><em>How does this work?</em></a>
                                <ol *ngIf="show">
                                <li [hidden]="screenMode == SINGLE_FILE_MODE">Select attachments and/or versions that you want to send by ticking the box. File(s) will load.</li>
                                <li [hidden]="screenMode == SINGLE_FILE_MODE">Click <strong>NEXT</strong>.</li>
                                <li>Fill in the form. Subject: this is pre-populated but can be edited. Start typing the recipient’s name (select from the available options). Write a message to the recipient.</li>
                                <li>Click <strong>SEND</strong>.</li>
                                </ol>
                            </div>
                        </div>

                        <div class="fieldset-buttons">
                            <core-helpers-forms-button
                                [type]="'grey'"
                                [text]="'Cancel'"
                                (submit)="cancel()"
                                [hidden]="view != VIEW_SELECTOR || !isSelectionReady() "
                            ></core-helpers-forms-button>
                            <core-helpers-forms-button
                                [type]="'grey'"
                                [text]="'Previous'"
                                (submit)="setView(VIEW_SELECTOR)"
                                [hidden]="view != VIEW_SENDER || screenMode == SINGLE_FILE_MODE"
                            ></core-helpers-forms-button>
                            <core-helpers-forms-button-white
                                [text]="'Next'"
                                (submit)="setView(VIEW_SENDER)"
                                [hidden]="view != VIEW_SELECTOR || !isSelectionReady()"
                            ></core-helpers-forms-button-white>
                            <core-helpers-forms-button-white
                                [text]="'Send'"
                                (submit)="onSubmit()"
                                [hidden]="view != VIEW_SENDER || !isTransferReady()"
                            ></core-helpers-forms-button-white>
                        </div>
                    </div>
                    <div class="main-transfer-content choose-options">
                        <share-transfer-select-files-section
                            [hidden]="view != VIEW_SELECTOR"
                            [project]="project"
                            [files]="filesSelected"
                            (selectedChange)="onChange($event);"
                        ></share-transfer-select-files-section>
            
                        <div class="share-send-box" [hidden]="(view != VIEW_SENDER &&  view != VIEW_SEND_DONE)">
                            <h4 class="h4_label">CHOOSE THE TRANSFER OPTIONS</h4>
                            <form [formGroup]="form" action="" >
                                <ng-container *ngIf="signatureOption">
                                    <div class="transfer-options-form">
                                        <div class="transfer-options-signature">
                                            <core-helpers-forms-input-checkbox
                                                [label]="'Add e-signatures to PDF files'"
                                                [name]="'with_signatures'"
                                                [defaultChecked]="true"
                                                [form]="form"
                                                (checkedChange)="onAddSignatureChange($event)"
                                            ></core-helpers-forms-input-checkbox>
                                        </div>
                                    </div>
                                </ng-container>
                                <app-share-send-box
                                    [subjectPlaceholder]="subject"
                                    [form]="form"
                                    [files]="filesSelected"
                                ></app-share-send-box>

                            </form>
                        </div>
                    </div>
                </ng-container>
                <ng-template #anyAccessToSend>
                    <core-helpers-box-alert-message-icon 
                        [text]="'You do not have permission to send this project files.'"
                        [icon]="'warning'"
                    ></core-helpers-box-alert-message-icon>
                </ng-template>
            </div>
        </div>
    </section>
    <section *ngIf="status == DONE && permission && view == VIEW_DONE" class="main-content">
        <div class="app-main">
            <core-helper-box-done-close-tab
                [type]="'done'"
                [message]="'Done!'"
                [text]="'Your work here is done, feel free to close the tab now.'"
            ></core-helper-box-done-close-tab>
        </div>
    </section>
</div>
